import { render, staticRenderFns } from "./PostalAddressField.vue?vue&type=template&id=9d090680&"
import script from "./PostalAddressField.vue?vue&type=script&lang=js&"
export * from "./PostalAddressField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports